import { defineStore } from 'pinia'

export const contractStore = defineStore('contract', {
  state: () => ({
    number: null,
    city: null,
    zip: null,
    street: null,
    streetNumber: null,
    startDate: null,
    endDate: null,
    accountingArea: null,
    tplatz: null,
    contractText: null,
    contractType: null,
    premium: null,
    sites: {}
  }),
  getters: {
    isCampusflats: state => parseInt(state.contractType) === 1001
  },
  persist: true
})
